import { Capacitor } from '@capacitor/core';

export function getPlatform() {
  if (typeof Capacitor?.getPlatform === 'function') {
    return Capacitor.getPlatform();
  }
  return Capacitor?.platform || 'web';
}

export function isNativePlatform() {
  if (typeof Capacitor?.isNativePlatform === 'function') {
    return Capacitor.isNativePlatform();
  }
  const platform = getPlatform();
  return platform === 'ios' || platform === 'android';
}
